import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { CircularProgress } from '@material-ui/core';
import styles from './LocalesSwitcher.styles';
import Button from 'components/Button';

const useStyles = makeStyles(styles);

export const getNextLocale = (supportedLanguages, selectedLocale) => {
  let index = supportedLanguages.findIndex(item => item === selectedLocale);
  index += 1;

  if (index >= supportedLanguages.length) {
    index = 0;
  }
  return supportedLanguages[index];
};

const Component = props => {
  const {
    selectedLocale,
    supportedLanguages,
    switchLanguages,
    loadingSwitchLocale,
  } = props;
  const classes = useStyles(props);
  const nextLocale = getNextLocale(supportedLanguages, selectedLocale);
  if (supportedLanguages && supportedLanguages.length >= 2) {
    return (
      <div>
        {!loadingSwitchLocale && (
          <Button
            variant={'text'}
            isPrimary={false}
            classes={{ root: classes.localesSwitcher }}
            data-cmp="LocaleSwitcher"
            text={
              loadingSwitchLocale
                ? 'admin_loading_locale'
                : `admin.locales.language.switcher.${selectedLocale}`
            }
            onClick={() => {
              if (!loadingSwitchLocale) {
                switchLanguages(nextLocale);
              }
            }}
          />
        )}
        {loadingSwitchLocale && (
          <div className={classes.loaderContainer}>
            <CircularProgress className={classes.loader} size={10} />
          </div>
        )}
      </div>
    );
  } else {
    return null;
  }
};

Component.propTypes = {
  selectedLocale: PropTypes.string.isRequired,
  supportedLanguages: PropTypes.arrayOf(PropTypes.string).isRequired,
  switchLanguages: PropTypes.func.isRequired,
  loadingSwitchLocale: PropTypes.bool,
};

export default Component;
